var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 44,
    rx: 8,
    fill: "#074EE8",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 17C26.8802 17 27.7202 17 28.362 17.327C28.9265 17.6146 29.3854 18.0735 29.673 18.638C30 19.2798 30 20.1198 30 21.8V27.2C30 28.8802 30 29.7202 29.673 30.362C29.3854 30.9265 28.9265 31.3854 28.362 31.673C27.7202 32 26.8802 32 25.2 32H16.8C15.1198 32 14.2798 32 13.638 31.673C13.0735 31.3854 12.6146 30.9265 12.327 30.362C12 29.7202 12 28.8802 12 27.2V21.8C12 20.1198 12 19.2798 12.327 18.638C12.6146 18.0735 13.0735 17.6146 13.638 17.327C14.2798 17 15.1198 17 16.8 17M25 17H17V16C17 13.7909 18.7909 12 21 12C22.3572 12 23.5565 12.6759 24.2797 13.7095M21 25.5C22.1046 25.5 23 24.6046 23 23.5C23 22.3954 22.1046 21.5 21 21.5C19.8954 21.5 19 22.3954 19 23.5C19 24.6046 19.8954 25.5 21 25.5ZM21 25.5V27.5",
    stroke: "#074EE8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.0ce0fb3704e4b64d651bf8e8a1eade35.svg";
export { ForwardRef as ReactComponent };